<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='openModalNotif' persistent='' max-width='380')
      //- template(v-slot:activator='{ on, attrs }')
      //-   v-btn(color='primary' dark='' v-bind='attrs' v-on='on')
      //-     | Open Dialog
      v-card(height="180px" style="text-align:center; padding:40px 30px 40px 30px")
        v-card-text()
          h2 Apakah anda yakin untuk membatalkan Kunjungan?
        v-card-actions(style="margin-top:10px")
          v-spacer
          v-btn(style="margin-right:120px" text='' @click='handleClose()')
            | Kembali
          v-btn(color='blue' text='' @click='hadleSubmit()')
            | Ya, Betul
</template>

<script>
export default {
name:"ModalNotifVisitor",
props:['openModalNotif','onClose','onConfirm'],

 data () {
      return {
        dialog: false,
      }
    },
  methods: {
    handleClose(){
      this.$emit("onClose", false)
    },
    hadleSubmit(){
      this.$emit("onConfirm",18)
      // this.$emit("onClose", false)
    }
  }
}
</script>

<style>

</style>